export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-universal-access-8f99b6228929618756f75d5e1ffb488d.svg";